import { render, staticRenderFns } from "./customer-picker.component.vue?vue&type=template&id=ddd5648c&scoped=true&"
import script from "./customer-picker.component.vue?vue&type=script&lang=ts&"
export * from "./customer-picker.component.vue?vue&type=script&lang=ts&"
import style0 from "./customer-picker.component.vue?vue&type=style&index=0&id=ddd5648c&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddd5648c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
installComponents(component, {VAutocomplete})
